import type { Nullable } from "models-webgl2";
import { Webgl2dRenderer } from "../webgl2d-renderer";
import { Webgl2Tool } from "./webgl2-tool";
import { Webgl2Component } from "../../webgl2-component";

export class CanvasResizeTool extends Webgl2Tool {
  private _currComponent: Nullable<Webgl2Component>;

  constructor(private readonly _renderer: Webgl2dRenderer) {
    super();
  }

  public onAssign() {
    this._renderer.selectComponent(this._renderer.chessGridComponent);
    this._renderer.canvasResizeSelectionComponent.copyComponentTransform(
      this._renderer.chessGridComponent,
    );
  }

  public onUnAssign() {
    this._renderer.selectComponent(null);
  }

  public onMouseDown(e: MouseEvent) {
    return this._handleDown(e);
  }

  public onMouseMove(e: MouseEvent) {
    this._handleMove(e);
  }

  public onMouseEnded(e: MouseEvent) {
    return this._handleUp(e);
  }

  public onTouchStart(e: TouchEvent) {
    return this._handleDown(e);
  }

  public onTouchMove(e: TouchEvent) {
    this._handleMove(e);
  }

  public onTouchEnded(e: TouchEvent) {
    return this._handleUp(e);
  }

  private _handleDown(e: MouseEvent | TouchEvent) {
    this._currComponent = this._renderer.findComponentUnderMouse(e);

    if (this._currComponent?.onMouseDown) {
      this._currComponent?.onMouseDown(e);
    } else {
      this._renderer.tools.handTool.handleDown(e);
    }
  }

  private _handleMove(e: MouseEvent | TouchEvent) {
    if (this._currComponent) {
      this._currComponent.onMouseMove?.(e);
    } else {
      this._renderer.tools.handTool.handleMove(e);
    }
  }

  private _handleUp(e: MouseEvent | TouchEvent) {
    this._currComponent?.onMouseUp?.(e);
  }
}

export default CanvasResizeTool;
